export default "__VITE_ASSET__Deojv9Fj__"